<template>
  <div class="container-fluid">
    <div class="loading" v-if="loading">Loading&#8230;</div>

    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Usuarios del sistema</h1>
          <p class="view-header__subtitle">Administrá los usuarios, sus roles de acceso y las cajas asignadas.</p>
        </div>
      </div>
    </div>

    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <input v-model="doSearch" type="search" class="form-control" placeholder="Buscar usuario...">
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- TABLA -->
      <div class="col-md-8">
        <div class="data-table">
          <vdtnet-table
            ref="table"
            :fields="fields"
            :opts="opts"
            :selectCheckbox="0"
            container-class-name="table-responsive"
            class-name="table mb-0"
            @edit="changeUserId"
            @delete="deleteUser"
          />
        </div>
      </div>

      <!-- FORMULARIO -->
      <div class="col-md-4">
        <NewUser :userId="userId" @confirmsave="refreshTable()" />
      </div>
    </div>
  </div>
</template>

<script>
import VdtnetTable from '@/components/global/VdtnetTable.vue';
import NewUser from "../../sub-components/New-user.vue";

export default {
  components: {
    VdtnetTable,
    NewUser,
  },
  data: function () {
    return {
      loading: false,
      doSearch: '',
      userId: null,
      opts: {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
        ajax: {
          url: process.env.VUE_APP_BASE_URL+"/api/users/list",
          type: "GET",
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        },
        autoWidth: false,
        pageLength: 15,
        searching: true,
      },
      fields: {
        usuario: {
          label: "Usuario",
          searchable: true,
          align: "left",
          render: (_data, type, row) => {
            if (type !== 'display') return row.name;
            return `
              <div class="data-table__primary">${row.name}</div>
              <div class="data-table__secondary">${row.email || ''}</div>
            `;
          },
        },
        sucursal: { label: "Sucursal", searchable: true, align: "left" },
        role: { label: "Rol", searchable: true },
        estado: {
          isLocal: true,
          label: "Estado",
          width: "100px",
          align: "center",
          orderable: false,
          searchable: false,
          render: (_data, type, row) => {
            if (type !== 'display') return '';
            const isActive = row.active == 1;
            const variant = isActive ? 'success' : 'danger';
            const label = isActive ? 'Activo' : 'Inactivo';
            return `<span class="status-badge status-badge--${variant}">${label}</span>`;
          },
        },
        actions: {
          isLocal: true,
          label: "Acciones",
          width: "100px",
          align: "right",
          orderable: false,
          searchable: false,
          render: (_data, _type, row) => {
            const toggleIcon = row.active == 1 ? 'bi bi-person-slash' : 'bi bi-person-check';
            const toggleTitle = row.active == 1 ? 'Desactivar' : 'Activar';
            return `
              <div class="table-action-group">
                <button data-action="edit" class="table-action-btn" type="button" title="Editar">
                  <i class="bi bi-pencil"></i>
                </button>
                <button data-action="delete" class="table-action-btn" type="button" title="${toggleTitle}">
                  <i class="${toggleIcon}"></i>
                </button>
              </div>
            `;
          },
        },
      },

    }
  },
  watch: {
    doSearch(newValue, oldValue) {
      if (newValue.length >= 4 || oldValue.length >= 4) {
        this.$refs.table.search(this.doSearch);
      }
      if (newValue === "" && oldValue.length > 0) {
        this.$refs.table.search(this.doSearch);
      }
    },

  },
  methods: {
    refreshTable() {
      var vm = this;
      vm.userId = null;
      if (vm.$refs.table !== undefined) vm.$refs.table.reload();
    },
    changeUserId(data) {
      this.userId = data.id;
    },
    deleteUser(data) {
      const accion = data.active == 1 ? 'Desactivar' : 'Activar';
      if (confirm(`¿Está seguro que desea ${accion} este usuario?`) == true) {
        this.$http
          .get(`/api/users/toggleuser/${data.id}`)
          .then((response) => {
            if (!response.data.code == 200) {
              // no-op intencional
                            
            }
            alert(`Usuario modificado correctamente`);              
            this.refreshTable();
          });
      }
    },
  }


}
</script>